/* eslint-disable no-unreachable */
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import {Box, Button, Divider, IconButton, Stack, Typography} from '@mui/material';
import {useRef} from 'react';
import {toast} from 'react-toastify';
import Dev from 'src/components/Dev';
import DynamicFormInput from 'src/components/DynamicForm/DynamicFormInput';
import Counter from 'src/components/inputs/Counter';
import ItemBranchPicker from 'src/components/ItemBranchPicker';
import {ItemPrice} from 'src/components/Price';
import StyledLink from 'src/components/ui/StyledLink';
import {isNullOrEmpty} from 'src/utils/helperMethods';
import {getNumber} from 'src/utils/numberUtils';
import {getImageSrc} from 'src/utils/productUtils';

/* 
	item will contain all attributes from product  (IFF variatoni: common attributes overriden variation attributes like price and qty, name )
	check addItem method in ProductsGridSelectionItem.jsx
*/
export default function CartItem({
	item,
	handleItemChange = (id, changes) => {},
	handleItemQuantityChange,
	handleRemoveItem,
	showBranch = false,
	branch,
}) {
	const {price: defaultPrice, discount: defaultDiscount} = useRef(item).current;

	// const item_available_qty = item.infinite ? 10000 : item.derived.branch_quantity;
	return (
		<Stack spacing={2}>
			<Stack direction={{xs: 'column', sm: 'row'}} justifyContent="space-between">
				<Stack alignItems="center" spacing={2} direction="row">
					<img loading="lazy" alt="product" src={getImageSrc(item)} width={45} height={45} />
					<Stack>
						<StyledLink to={`/products/${item.product?.id ?? item.product}`}>
							<Typography variant="subtitle2">
								{item.name} {item.variation?.name && `- ${item.variation?.name}`}
							</Typography>
						</StyledLink>
						<Stack spacing={1} direction="row" justifyContent="space-between">
							<Typography sx={{fontSize: 14}}>الكمية: {getAvailableQuantity(item, branch)}</Typography>
							<ItemPrice item={item} />
						</Stack>
					</Stack>
				</Stack>

				{/* 		<Stack alignItems="center" spacing={1} direction="row" justifyContent="space-between">
					<TextField
						type="number"
						label="الكمية"
						placeholder="الكمية"
						size="small"
						name="selectedQuantity"
						defaultValue={1}
						sx={{maxWidth: 65, fontSize: 5}}
						value={item.selectedQuantity}
						onChange={(e) => handleItemQuantityChange(item.id, e.target.value)}
					/>

					<IconButton
						sx={{opacity: 0.8}}
						color="error"
						onClick={() => {
							handleRemoveItem(item.id);
						}}
					>
						<DeleteIcon fontSize="small" />
					</IconButton>
				</Stack>
 */}

				<Stack spacing={1} direction="row" alignItems={'center'}>
					{showBranch && (
						<ItemBranchPicker
							stocks={item.stocks}
							variationId={item.variation}
							value={item.branch ?? ''}
							onChange={(e, option) => {
								handleItemChange(item.id, {
									...item,
									branch: e.target.value,
								});
							}}
						/>
					)}

					<Counter
						defaultValue={item.selectedQuantity}
						onChange={(newValue) => handleItemQuantityChange(item.id, newValue)}
						min={1}
						max={item.infinite ? 10000 : item.derived.branch_quantity}
					/>

					<IconButton
						sx={{opacity: 0.8}}
						color="error"
						onClick={() => {
							handleRemoveItem(item.id);
						}}
					>
						<DeleteIcon fontSize="small" />
					</IconButton>
				</Stack>
			</Stack>
			{/* render dynamic inputs */}
			{!isNullOrEmpty(item.inputs) && (
				<DynamicFormInput
					value={item.selectedInputs?.[0]?.value ?? ''}
					setFieldValue={(inputName, value, selectedOption) => {
						// selectedOption will be set only if the input is picker
						const {name, label} = item.inputs[0];
						const price = getNumber(selectedOption?.price, defaultPrice);
						handleItemChange(item.id, {
							...item,
							price,
							discount: selectedOption?.price ? 0 : defaultDiscount,
							selectedInputs: [{name, label, value, price}],
						});
					}}
					input={{...item.inputs[0], valueKey: 'value', labelKey: 'value'}}
				/>
			)}

			{/* <Dev title={'item (JSON)'} object={item} /> */}
			<Divider />
		</Stack>
	);
}

const getAvailableQuantity = (item, branch) => {
	if (item.infinite) return '∞';
	if (!branch) return item.derived.branch_quantity;
	const stock = item.stocks.find((b) => item.variation == b.variation && b.branch == branch);
	return getNumber(stock?.quantity, item.derived.branch_quantity);
};
